import RowOfIcons from './RowOfIcons';
import TabVariables from '../Tabs/TabVariables';
import DoGuide from './DoGuide';
import * as TreeFunctions from '../utilities/TreeFunctions';
// import * as CoreFns from '../utilities/CoreFns';

function App(props) {

  var currentList = props.currentList;
  var organicChanges = props.organicChanges;
  var error = props.error;
  var addToExtraScreen = props.addToExtraScreen;
  var changeTab = props.changeTab;
  var tabSelected = props.tabSelected;
  var userNos = props.userNos;
  var selectTab = tabSelected.s;
  var leftColRefs = props.leftColRefs;
  var setLeftColRefs = props.setLeftColRefs;
  // var logInState = props.logInState;

  var selectedText = '';
  var contents;
  if (selectTab === 0){
    selectedText = 'Variables';
    contents = <TabVariables addToExtraScreen={addToExtraScreen} organicChanges={organicChanges} currentList={currentList} error={error} userNos={userNos} questions={TreeFunctions.ownVariableQuestions()} source='ov' leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs} />

  }else if (selectTab === 1 ){
    selectedText = 'Structs';
    contents = <TabVariables addToExtraScreen={addToExtraScreen} organicChanges={organicChanges} currentList={currentList} error={error} userNos={userNos} questions={TreeFunctions.ownStructQuestions()} source='os' leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs} />
  // }else if (selectTab === 2){
  //   selectedText = 'GenAI';
  //   contents = <TabVariables addToExtraScreen={addToExtraScreen} organicChanges={organicChanges} currentList={currentList} error={error} userNos={userNos} questions={TreeFunctions.ownVariableQuestions()} source='ai' leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs} />
  }


  var options = [{i:'carbon:value-variable', n:'Variables'}, {i:'ic:baseline-data-object', n:'Structs'}];
  // if (CoreFns.isAdmin(logInState)){
  //   options.push({i:'eos-icons:ai', n:'Gen AI'});
  // }

  var icons = <RowOfIcons changeTab={changeTab} tabSelected={tabSelected} options={options}/>
   return <div className='container' ><center><br/>
            <DoGuide addToExtraScreen={addToExtraScreen} set={{t:'tabUserDefinitions'}} /><br/>
            {icons}
            <br/>
            <p className='lead mb-0' style={{color:'white', fontWeight:700}} >{selectedText}</p><br/>
            </center>
            {contents}
   </div>

}

export default App;
